import { Alert, AlertTitle, Box, IconButton } from '@mui/material';
import { Info, Close } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import apiClient from '../../services/apiClient';

/**
 * Pilot Mode Banner
 * 
 * Displays a banner when pilot mode is active, warning users not to enter PHI
 */
const PilotModeBanner = () => {
  const [pilotMode, setPilotMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check pilot mode status
    const checkPilotMode = async () => {
      try {
        const response = await apiClient.get('/health/pilot-mode');
        if (response.data) {
          setPilotMode(response.data.pilotMode || false);
        }
      } catch (error) {
        console.warn('Failed to check pilot mode status:', error);
        // Default to false if check fails
        setPilotMode(false);
      } finally {
        setLoading(false);
      }
    };

    checkPilotMode();

    // Check if user has dismissed the banner
    const dismissedState = localStorage.getItem('pilotModeBannerDismissed');
    if (dismissedState === 'true') {
      setDismissed(true);
    }
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pilotModeBannerDismissed', 'true');
  };

  // Don't show if not in pilot mode or if dismissed
  if (loading || !pilotMode || dismissed) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Alert 
        severity="info" 
        icon={<Info />}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleDismiss}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
        sx={{
          backgroundColor: '#e3f2fd',
          borderLeft: '4px solid #2196f3',
        }}
      >
        <AlertTitle>Pilot Mode (Non-PHI)</AlertTitle>
        <Box component="div" sx={{ mt: 1 }}>
          <strong>This is a controlled operational pilot.</strong> Please do not enter Protected Health Information (PHI) such as:
          <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>Clinical notes or medical diagnoses</li>
            <li>Prescription details</li>
            <li>Patient identifiers in messages</li>
            <li>Sensitive health information</li>
          </ul>
          Only use test data or non-identifiable information during this pilot phase.
        </Box>
      </Alert>
    </Box>
  );
};

export default PilotModeBanner;
